(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nw-atf-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-nw-carousel]').forEach(function (carousel) {
  var slides = carousel.querySelectorAll('.nw-atf-hero__slide');
  var dots = carousel.querySelectorAll('.nw-atf-hero__dot');
  if (slides.length < 2) return;

  var delay = (parseFloat(carousel.dataset.delay) || 5) * 1000;
  var autoplay = carousel.dataset.autoplay === 'true';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var index = 0;
  var timer = null;

  function show(next) {
    slides[index].classList.remove('is-active');
    if (dots[index]) dots[index].classList.remove('is-active');
    index = (next + slides.length) % slides.length;
    slides[index].classList.add('is-active');
    if (dots[index]) dots[index].classList.add('is-active');
  }

  function start() {
    if (!autoplay || reduceMotion) return;
    stop();
    timer = setInterval(function () { show(index + 1); }, delay);
  }

  function stop() {
    if (timer) clearInterval(timer);
    timer = null;
  }

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      show(i);
      start();
    });
  });

  carousel.addEventListener('mouseenter', stop);
  carousel.addEventListener('mouseleave', start);
  carousel.addEventListener('focusin', stop);
  carousel.addEventListener('focusout', start);

  start();
});

  } catch(e) { console.error(e); }
})();
})();
